import { Injectable, inject } from '@angular/core';

import { Action, Selector, State, StateContext } from '@ngxs/store';
import { tap } from 'rxjs';

import {
  AccountClearAction,
  CreateAddressAction,
  DeleteAddressAction,
  GetUserDetailsAction,
  UpdateAddressAction,
  UpdateUserPasswordAction,
  UpdateUserProfileAction,
} from '../action/account.action';
import { IPermission } from '../interface/role.interface';
import { AccountService } from '../services/account.service';
import { IAccountUser, IAccountUserUpdatePassword } from './../interface/account.interface';
import { IUserAddress } from '../interface/user.interface';

export class AccountStateModel {
  user: IAccountUser | null;
  permissions: IPermission[];
}

@State<AccountStateModel>({
  name: 'account',
  defaults: {
    user: null,
    permissions: [],
  },
})
@Injectable()
export class AccountState {
  private accountService = inject(AccountService);

  @Selector()
  static user(state: AccountStateModel) {
    return state.user;
  }

  @Selector()
  static permissions(state: AccountStateModel) {
    return state.permissions;
  }

  // @Action(GetUserDetailsAction)
  // GetUserDetails(ctx: StateContext<AccountStateModel>) {
  //   return this.accountService.GetUserDetails().pipe(
  //     tap({
  //       next: result => {
  //         ctx.patchState({
  //           user: result,
  //           permissions: result.permission,
  //         });
  //       },
  //       error: err => {
  //         throw new Error(err?.error?.message);
  //       },
  //     }),
  //   );
  // }

  @Action(UpdateUserProfileAction)
  updateProfile(
    _ctx: StateContext<AccountStateModel>,
    { payload: _payload }: UpdateUserProfileAction,
  ) {
    // Update Profile Logic Here
  }

  @Action(UpdateUserPasswordAction)
  updatePassword(
    _ctx: StateContext<IAccountUserUpdatePassword>,
    { payload: _payload }: UpdateUserPasswordAction,
  ) {
    // Update Password Logic Here
  }

  @Action(CreateAddressAction)
  CreateAddress(ctx: StateContext<AccountStateModel>, action: CreateAddressAction) {
    const state = ctx.getState();
    const user = state.user;

    if (!user) {
      return;
    }

    const address = action.payload as IUserAddress;
    const addressList = [...(user.address ?? []), address];

    ctx.patchState({
      user: {
        ...user,
        address: addressList,
      },
    });
  }

  @Action(UpdateAddressAction)
  UpdateAddress(ctx: StateContext<AccountStateModel>, action: UpdateAddressAction) {
    const state = ctx.getState();
    const user = state.user;

    if (!user) {
      return;
    }

    const updatedAddress = action.payload as IUserAddress;
    const addressList = (user.address ?? []).map(address =>
      address.id === action.id ? { ...address, ...updatedAddress, id: action.id } : address,
    );

    ctx.patchState({
      user: {
        ...user,
        address: addressList,
      },
    });
  }

  @Action(DeleteAddressAction)
  DeleteAddress(ctx: StateContext<AccountStateModel>, action: DeleteAddressAction) {
    const state = ctx.getState();
    const user = state.user;

    if (!user) {
      return;
    }

    const addressList = (user.address ?? []).filter(address => address.id !== action.id);

    ctx.patchState({
      user: {
        ...user,
        address: addressList,
      },
    });
  }

  @Action(AccountClearAction)
  AccountClear(ctx: StateContext<AccountStateModel>) {
    ctx.patchState({
      user: null,
      permissions: [],
    });
  }
}
